module.exports = __webpack_public_path__ + "static/media/heide_heloise.ba75a7b8.png";